import { Injectable } from '@angular/core';
import {
  CategoryService,
  ListOfCategorys,
  SubcategoryService,
  SubgroupService,
  GlobalQuestionService } from '../../../../../swaggerServices';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ICategory } from '../../tax-return-builder/tax-return-builder';

@Injectable()
export class GlobalBuilderService {
  categories: ListOfCategorys;
  subcategories: any;
  constructor(private categoryService: CategoryService,
    private subCategoryService: SubcategoryService,
    private subgroupService: SubgroupService,
    private questionService: GlobalQuestionService) { }


  getCategories(taxReturnTypeId: number): Observable<ICategory[]> {
    return this.categoryService.getCategorys(taxReturnTypeId).pipe(
      map((results: any) => {
        results.categories.map(cat => {
          cat['isCollapsed'] = true;
          cat['isLoading'] = false;
        });
        results.categories.sort((a, b) => {
          if (a.order === null) return 1;
          if (b.order === null) return -1;
          return a.order > b.order ? 1 : -1;
        });
        return results.categories;
      })
    );
  }

  getSubcategories(taxReturnTypeId: number) {
    return this.subCategoryService.getSubcategorys(taxReturnTypeId).pipe(map((results: any) => {
      return results.subcategories.filter(sc => sc.status === 0);
    }));
  }

  getSubgroups(taxReturnTypeId: number) {
    return this.subgroupService.getSubgroups(taxReturnTypeId).pipe(map((results: any) => {
      return results.subgroups.filter(sg => sg.status === 0);
    }));
  }

  getQuestions() {
    return this.questionService.getGlobalQuestions().pipe(map((results: any) => {
      return results.questions;
    }));
  }

  getCategoryById(catId: number, taxYr: string): Observable<any> {
    return this.categoryService.getCategoryById(catId).pipe(
      map((category: any) => {
        category.subcategories.map( subcat => {
          subcat['isCollapsed'] = true;
          subcat.subgroups.map( group => {
            group['isCollapsed'] = true;
            group['order'] = group.subgroupSubcategoryOrder.order;
            group.questions = group.questions.filter(q => q.year === Number(taxYr));
            group.questions.map(q =>  {
              if (q.isTab) subcat.tabQuestion = q;
              q.order = q.subGroupOrder.order;
              q.canRemove = false;
            });
            group.questions.sort((a, b) => a.order - b.order);
          });
          subcat.subgroups.sort((a, b) => a.order - b.order);
        });
        category.subcategories.sort((a, b) => a.order - b.order);
        return category;
      })
    );
  }

}
